import React, { PureComponent } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import {
  Form,
  Col,
  InputGroup,
  Input,
  Alert,
  Row,
  InputGroupAddon,
  FormGroup,
} from 'reactstrap';
import classNames from 'classnames';
import {
  postUserBankAccount,
  doFetchProvinces,
  getBankList,
} from '../../../../actions/postalCodeAction';
import Button from '../../../Forms/Button';
import { isNumeric } from '../../../../helpers/regex';
import { parsePhone, ImagesCompressor } from '../../../../utils';

import { InputSelect } from '../../../Forms/Input';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import SellerVerification from '../../SellerVerification';
import { CustomDropzone } from '../../../Forms';
import { InfoCircleFilled } from '@ant-design/icons';
import { Switch } from 'antd';
import { ModalPhotoGuidance } from './ModalPhotoGuidance';
import InputMask from 'react-input-mask';
import 'antd/es/switch/style/css';

// ASSETS
import PlaceholderUploadIcon from '../../../../images/image-placeholder.png';
import ArrowDown from '../../../../images/arrowDown.png';

class SubmitPhoneV2 extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      numberPhone: '',
      nama: '',
      noRek: '',
      bankName: '',
      idNumber: '',
      idName: '',
      idAddress: '',
      type: 'NPWP',
      photo: '',
      photoUrl: '',
      photoCompressed: '',
      isModalGuidanceOpen: false,
      isError: false,
      _errors: null,
      _disable: false,
      _province: null,
      _provinceSelected: null,
      _provinceList: [{ value: '', label: 'Provinsi*' }],
      _errorLocation: null,
      bankList: [{ value: '', label: 'Select Bank Name' }],
      oldBankList: [{ value: '', label: 'Select Bank Name' }],
      selectedBank: null,
      isOpenBankList: false,
      isOpen: false,
      isDisabledPhoneNumber: false,
      isDisabledBankAccountData: false,
      isDisabledSellerLocation: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.formValidation = this.formValidation.bind(this);
    this._process = this._process.bind(this);
    this._handleSelectProvinceChange =
      this._handleSelectProvinceChange.bind(this);
  }

  selectedType = () => {
    return this.state.type === 'NPWP' ? 'NPWP' : 'e-KTP';
  };

  formValidation() {
    let errors = {};
    const selectedType = this.state.type === 'NPWP' ? 'NPWP' : 'e-KTP';
    const idNumber = this.state.idNumber.replace(/\W+|\s+|[a-zA-Z]+/g, '');

    if (selectedType === 'e-KTP' && idNumber.length !== 16)
      errors['idNumber'] = [`e-KTP number is not valid`];
    if (
      selectedType === 'NPWP' &&
      (idNumber.length < 15 || idNumber.length > 16)
    )
      errors['idNumber'] = [`NPWP number is not valid`];
    if (!idNumber)
      errors['idNumber'] = [`Please input your ${selectedType} number`];
    if (!this.state.idName)
      errors['idName'] = [
        `Please input your name according on your ${selectedType}`,
      ];
    if (!this.state.idAddress)
      errors['idAddress'] = [
        `Please input your address according on your ${selectedType}`,
      ];
    if (!this.state.photo)
      errors['photo'] = [`Please upload your ${selectedType} photo`];
    if (!this.state.numberPhone)
      errors['numberPhone'] = ['Please input your phone number.'];
    if (!this.state.nama)
      errors['nama'] = ['Please input account holder name.'];
    if (!this.state.noRek) errors['noRek'] = ['Please input account number.'];
    else if (!isNumeric(this.state.noRek))
      errors['noRek'] = ['Account number must be numeric.'];
    if (!this.state.bankName) errors['bankName'] = ['Please input bank name.'];
    if (!this.state._provinceSelected || this.state._provinceSelected === '')
      errors['_provinceSelected'] = ['Please input your location.'];

    if (Object.keys(errors).length) {
      toast.error('Please check your form and try again.', {
        position: 'top-right',
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
      });

      this.setState({
        _errors: {
          errors: { ...errors },
          status_code: 422,
          message: 'Please check your form and try again.',
        },
      });
    }
    return errors;
  }

  errorChecker(params) {
    if (this.state._errors !== null && this.state._errors.status_code === 422) {
      const isErrorExist =
        Object.keys(this.state._errors.errors).filter((err) => err === params)
          .length > 0;
      if (isErrorExist) {
        return (
          <div className="error-seller-regist">
            <span>{this.state._errors.errors[`${params}`][0]}</span>
          </div>
        );
      }
    }
    return false;
  }

  _inputHp = (e) => {
    if (e.target.value.length > 12) {
      return;
    }

    this.setState({
      numberPhone: e.target.value.replace(/\W+|\s+|[a-zA-Z]+/g, ''),
    });
  };

  handleChangeIdNumber = (e) => {
    this.setState({
      idNumber: e.target.value,
    });
  };

  handleChange(e) {
    const lastState = { ...this.state };
    const errors = {};
    lastState[e.target.name] = e.target.value;
    this.setState({ ...lastState });
  }

  handleChangeBankList = (e) => {
    this.setState({
      bankName: e.target.value,
    });
    const newBankList = this.state.oldBankList.filter((t) =>
      t.label.toLowerCase().includes(e.target.value.toLowerCase()),
    );
    this.setState({
      bankList: newBankList,
    });
  };

  async _process(e) {
    e.preventDefault();
    const resultValidation = this.formValidation();
    if (this.state.numberPhone && Object.keys(resultValidation).length === 0) {
      await this.setState({ isError: false, _errors: null });
      const dataBank = {
        account_name: this.state.nama,
        account_number: this.state.noRek,
        bank_name: this.state.bankName,
        province: this.state._provinceSelected,
      };
      this.props.setPhonePayload({
        id_card: this.state.idNumber.replace(/\W+|\s+|[a-zA-Z]+/g, ''),
        full_name: this.state.idName,
        address: this.state.idAddress,
        type: this.state.type,
        seller_verification_image: this.state.photoCompressed,
      });

      await this.props.onClick(this.state.numberPhone, dataBank);
    }
  }

  _handleKeyPress = (event) => {
    const re = /[0-9]+/g;
    if (!re.test(event.key)) {
      event.preventDefault();
    }
  };

  componentDidMount() {
    this.props.getProvinces();
    this.props.fetchBankList();

    const dataUser = this.props.userdata && this.props.userdata.userdata;

    if (dataUser?.seller_verification_info?.length) {
      const existingData = dataUser.seller_verification_info[0];
      const phoneNumberVerified = existingData.active;
      const hasPhoneNumber = !!existingData.mobile_number;
      const isDisabledPhoneNumber = phoneNumberVerified && hasPhoneNumber;
      const alreadyHasLocation = !!dataUser.user_setting.seller_location_id;

      this.setState({
        numberPhone: existingData.mobile_number?.replace('+62', ''),
        _provinceSelected: dataUser.user_setting.seller_location_id,
        isDisabledPhoneNumber,
        isDisabledSellerLocation: alreadyHasLocation,
      });

      if (isDisabledPhoneNumber) {
        this.props.setIsVerifiedAlready(true);
      }

      const bankAccount = this.props.dataUserBankAccount.data;

      if (bankAccount && bankAccount.length) {
        this.setState({
          nama: bankAccount[0].account_name,
          noRek: bankAccount[0].account_number,
          bankName: bankAccount[0].bank_name,
          isDisabledBankAccountData: true,
        });
      }

      if (existingData.id_card) {
        this.setState({
          idNumber: existingData.id_card,
          idName: existingData.name || '',
          idAddress: existingData.address || '',
          type: existingData.type === 'NPWP' ? 'NPWP' : 'KTP',
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const dataUser = this.props.userdata && this.props.userdata.userdata;

    if (dataUser && dataUser.country_code !== 'IDN') {
      this.props.history.push('/');
    }

    if (prevProps.isFetch && this.props.error && this.state._disable)
      this.setState({ _disable: !this.state._disable, isError: true });
    if (this.state._disable && prevProps.onUnverified)
      this.setState({ _disable: false }, () => {
        this.props.postUserBankAccount({
          account_name: this.state.nama,
          account_number: this.state.noRek,
          bank_name: this.state.bankName,
          seller_location_id: this.state._province,
        });
      });

    const { dataProvinces, dataBankList } = this.props;

    if (
      dataProvinces.isFetch === false &&
      dataProvinces.isFetch !== prevProps.dataProvinces.isFetch
    ) {
      if (dataProvinces.data.length && dataProvinces.status_code === 200) {
        const def = { value: '', label: 'Provinsi*' };
        const { data } = dataProvinces;
        let province = data.map((province, index) => ({
          value: province.id,
          label: province.name,
        }));
        let { _provinceSelected } = this.state;
        if (_provinceSelected == '') {
          const getProvince = province.filter(
            (prov) => prov.label == this.state._province,
          );
          if (getProvince.length) _provinceSelected = getProvince[0].value;
        }
        this.setState({ _provinceList: [def, ...province], _provinceSelected });
      }
    }

    if (prevState._errors !== this.state._errors) {
      switch (this.state._errors) {
        case 422:
          return toast.error('Please check your form and try again.', {
            position: 'top-right',
            autoClose: 5000,
            closeOnClick: true,
            pauseOnHover: true,
          });
        case 500:
          return toast.error(
            'Houston, we have a problem!. Please inform our friendly staff via Whatsapp: +6281210005425.',
            {
              position: 'top-right',
              autoClose: 5000,
              closeOnClick: true,
              pauseOnHover: true,
            },
          );
        default:
          break;
      }
    }

    if (
      dataBankList.isFetch === false &&
      dataBankList.isFetch !== prevProps.dataBankList.isFetch
    ) {
      if (dataBankList.data.length && dataBankList.status_code === 200) {
        const def = { value: '', label: 'Select Bank Name' };
        const { data } = dataBankList;
        let bankListOptions = data.map((item) => ({
          value: item.code,
          label: item.name,
          routing_code: item.routing_code,
        }));
        this.setState({
          bankList: bankListOptions,
          oldBankList: bankListOptions,
        });
      }
    }
  }

  _renderError() {
    const { _errors } = this.state;

    if (_errors !== null) {
      switch (_errors.status_code) {
        case 422:
          return toast.error('Please check your form and try again.', {
            position: 'top-right',
            autoClose: 5000,
            closeOnClick: true,
            pauseOnHover: true,
          });
        case 500:
          return toast.error(
            'Houston, we have a problem!. Please inform our friendly staff via Whatsapp: +6281210005425.',
            {
              position: 'top-right',
              autoClose: 5000,
              closeOnClick: true,
              pauseOnHover: true,
            },
          );
        default:
          break;
      }
    }
    return null;
  }

  openModalVerification() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  _handleSelectProvinceChange(selected) {
    const { _errors } = this.state;
    const newErrors =
      _errors &&
      _errors.errors &&
      Object.keys(_errors.errors).reduce((err, errKey) => {
        if (errKey !== '_provinceSelected')
          return {
            ...err,
            [errKey]: _errors.errors[errKey],
          };
        else
          return {
            ...err,
          };
      }, {});
    this.setState({
      _province: selected?.label,
      _provinceSelected: selected?.value,
      _errors:
        newErrors &&
        (Object.keys(newErrors).length
          ? {
              ..._errors,
              errors: newErrors,
            }
          : null),
    });
  }

  selectBankHandler(selectedBank) {
    this.setState({
      selectedBank,
      bankName: selectedBank.label,
      isOpenBankList: false,
    });
  }

  openBankListHandler() {
    this.setState({
      isOpenBankList: !this.state.isOpenBankList,
    });
  }

  async setPhotoHandler(photo) {
    const photoUrl = URL.createObjectURL(photo);
    const compress = async () => {
      const result = await ImagesCompressor(photo);
      return result;
    };
    const photoCompressed = await compress();
    this.setState({
      photo,
      photoUrl,
      photoCompressed,
    });
  }

  getPayloadPhone = () => {
    const dataPayloadPhone = {
      id_card: this.state.idNumber.replace(/\W+|\s+|[a-zA-Z]+/g, ''),
      full_name: this.state.idName,
      address: this.state.idAddress,
      type: this.state.type,
      seller_verification_image: this.state.photoCompressed,
    };

    return dataPayloadPhone;
  };

  isButtonDisabled = () => {
    const {
      numberPhone,
      nama,
      noRek,
      bankName,
      idNumber,
      idName,
      idAddress,
      type,
      photo,
      photoUrl,
      photoCompressed,
    } = this.state;
    const photoStillEmpty = !photo && !photoUrl && !photoCompressed;

    return (
      !numberPhone ||
      !nama ||
      !noRek ||
      !bankName ||
      !idNumber ||
      !idName ||
      !idAddress ||
      photoStillEmpty
    );
  };

  render() {
    const { dataProvinces } = this.props;
    const content = dataProvinces.isFetch ? (
      <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
        <ReactLoading
          type={'spokes'}
          color={'#159953'}
          height={45}
          width={45}
        />
      </div>
    ) : (
      <Form onSubmit={this._process} className="form-identitas">
        <SellerVerification
          phoneNumber={this.state.numberPhone}
          doRefreshToken={this.props.doRefreshToken}
          doVerifyOtp={this.props.doVerifyOtp}
          doSentCitCall={this.props.doSentCitCall}
          doSentSMS={this.props.doSentSMS}
          doSubmitPhone={this.props.doSubmitPhone}
          isOpen={this.state.isDisabledPhoneNumber ? false : this.props.isOpen}
          toggle={this.props.toggleModalSellerVerification}
          payloadSubmitPhone={this.getPayloadPhone()}
        />
        <Row md={12} id="text-info">
          <div>
            <p>
              We need to verify your data before we continue, please fulfill the
              form below. Please complete the following KYC form to verify your
              identity, as required by Indonesian law.
            </p>
          </div>
        </Row>
        <Row md={12} id="info-col">
          <p>
            Your privacy and data is protected will never be shared with any 3rd
            parties.
          </p>
        </Row>
        <Row>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Switch
              checked={this.state.type === 'KTP'}
              onChange={() => {
                const type = this.state.type === 'NPWP' ? 'KTP' : 'NPWP';
                this.setState({
                  type,
                  idNumber: '',
                  idName: '',
                  idAddress: '',
                  photo: '',
                  photoUrl: '',
                  photoCompressed: '',
                });
              }}
              style={{
                marginRight: 4,
              }}
            />
            Click the toggle if you don't have NPWP
          </div>
        </Row>
        <Row>
          <Col md="12" style={{ padding: 0 }}>
            <TextField style={{ padding: '0px' }}>
              <div className="title-form">{this.selectedType()} Number</div>
              <InputMask
                onChange={this.handleChangeIdNumber}
                value={this.state.idNumber}
                mask={
                  this.state.type === 'NPWP'
                    ? '99.999.999.9-999.999'
                    : '9999999999999999'
                }
              >
                <Input
                  className="info-input-user"
                  type="text"
                  name="idNumber"
                  placeholder={`Enter ${this.selectedType()} Number`}
                  autocomplete="off"
                />
              </InputMask>
            </TextField>
            {this.errorChecker('idNumber')}
          </Col>
        </Row>
        <Row>
          <Col md="12" style={{ padding: 0 }}>
            <TextField style={{ padding: '0px' }}>
              <div className="title-form">Name</div>
              <Input
                className="info-input-user"
                type="text"
                name="idName"
                onChange={this.handleChange}
                value={this.state.idName}
                placeholder={`Enter your name according to ${this.selectedType()}`}
                autocomplete="off"
              />
            </TextField>
            {this.errorChecker('idName')}
          </Col>
        </Row>
        <Row>
          <Col md="12" style={{ padding: 0 }}>
            <TextField style={{ padding: '0px' }}>
              <div className="title-form">Address</div>
              <Input
                className="info-input-user"
                type="text"
                name="idAddress"
                onChange={this.handleChange}
                value={this.state.idAddress}
                placeholder={`Enter your address according to ${this.selectedType()}`}
                autocomplete="off"
              />
            </TextField>
            {this.errorChecker('idAddress')}
          </Col>
        </Row>
        <Row>
          <Col md={6} style={{ padding: 0 }}>
            <TextField style={{ padding: '0px' }}>
              <div className="title-form">{this.selectedType()} Photo</div>
              <div
                className="title-form"
                style={{
                  fontSize: 12,
                  fontWeight: 'bold',
                  marginTop: -8,
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  this.setState({
                    isModalGuidanceOpen: true,
                  });
                }}
              >
                Photo Guidance
                <InfoCircleFilled
                  style={{ marginLeft: 4, fontSize: 10, color: '#8d8d8d' }}
                />
              </div>
              <CustomDropzone
                setPhoto={(file) => {
                  this.setPhotoHandler(file);
                }}
                className={`upload-photo-wrapper`}
              >
                <Row
                  align="middle"
                  justify="center"
                  style={{
                    height: 256,
                    borderRadius: 4,
                    borderWidth: 1,
                    borderColor: '#ebebeb',
                    borderStyle: 'solid',
                  }}
                >
                  <Col
                    md={12}
                    style={{ height: 'fit-content', alignSelf: 'center' }}
                  >
                    {this.state.photoUrl && (
                      <KickImage
                        height={256}
                        width={'100%'}
                        src={this.state.photoUrl}
                        alt="photo"
                        style={{
                          objectFit: 'contain',
                        }}
                      />
                    )}

                    {!this.state.photoUrl && (
                      <>
                        <KickImage
                          src={PlaceholderUploadIcon}
                          alt="upload image"
                          className="upload-package-photo"
                          style={{ width: 48 }}
                        />
                        <p className="upload-title" style={{ paddingTop: 8 }}>
                          Drag and Drop or Browse
                        </p>
                      </>
                    )}
                  </Col>
                </Row>
              </CustomDropzone>
            </TextField>
            {this.errorChecker('photo')}
          </Col>
        </Row>
        <Row md={12} id="info-col">
          <p>
            Input your active mobile, you will receive SMS or WhatsApp notifying
            about any updates regarding your products.
          </p>
        </Row>
        <Row>
          <Col md="12" style={{ padding: 0 }}>
            <TextField style={{ padding: '0px' }}>
              <div className="title-form">
                Mobile Number<span>*</span>
              </div>
              <InputGroup>
                <Col className="kode-area" sm={1} xs={2} style={{ padding: 0 }}>
                  <InputGroupAddon addonType="prepend">+62</InputGroupAddon>
                </Col>
                <Col
                  className="phone-number"
                  sm={11}
                  xs={10}
                  style={{ padding: 0 }}
                >
                  <Input
                    className="info-input-user phone"
                    type="text"
                    name="numberPhone"
                    onChange={(e) => this._inputHp(e)}
                    onKeyPress={this._handleKeyPress}
                    value={parsePhone(this.state.numberPhone)}
                    placeholder="Enter Mobile Number"
                    autocomplete="off"
                    disabled={this.state.isDisabledPhoneNumber}
                  />
                </Col>
              </InputGroup>
              <Alert
                className={classNames('seller__registration__feedback', {
                  'd-none': !this.state.isError,
                })}
                color="danger"
                isOpen={this.state.isError}
                transition
              >
                Phone number is already registered.
              </Alert>
            </TextField>
            {this.errorChecker('numberPhone')}
          </Col>
        </Row>
        <Row md={12} id="info-col">
          <p>
            Input the bank account you would like to be associated with all
            transactions occured in this platform.
          </p>
        </Row>
        <Row>
          <Col md="12" style={{ padding: 0 }}>
            <TextField style={{ padding: '0px' }}>
              <div className="title-form">Account Holder's Name</div>
              <Input
                className="info-input-user"
                type="text"
                name="nama"
                onChange={this.handleChange}
                value={this.state.nama}
                placeholder="Enter Account Holder's Name"
                autocomplete="off"
              />
            </TextField>
            {this.errorChecker('nama')}
          </Col>
        </Row>
        <Row>
          <Col md="12" style={{ padding: 0 }}>
            <TextField style={{ padding: '0px' }}>
              <div className="title-form">Account Number</div>
              <Input
                className="info-input-user"
                type="text"
                name="noRek"
                onChange={this.handleChange}
                value={this.state.noRek}
                placeholder="Enter Account Number"
                autocomplete="off"
              />
            </TextField>
            {this.errorChecker('noRek')}
          </Col>
        </Row>
        <Row>
          <Col md="12" style={{ padding: 0 }}>
            <TextField
              className="choose-bank-wrapper"
              style={{ padding: '0px' }}
            >
              <div className="title-form">Bank Name</div>
              <div className="input-wrapper-bank-name">
                <div
                  className="inside-wrapper-container"
                  onClick={() => {
                    this.openBankListHandler();
                  }}
                >
                  <Input
                    className="info-input-user"
                    type="text"
                    name="bankName"
                    onChange={this.handleChangeBankList}
                    value={this.state.bankName}
                    placeholder="Select Bank Name"
                    autocomplete="off"
                  />
                  <div className="down-icon-container">
                    <KickImage src={ArrowDown} alt="..." />
                  </div>
                </div>
                {this.state.isOpenBankList ? (
                  <div className="bank-list-container">
                    {this.state.bankList.map((bank) => {
                      return (
                        <div
                          className={`bank-card ${
                            this.state.selectedBank?.label === bank.label
                              ? 'selected'
                              : ''
                          }`}
                          onClick={() => this.selectBankHandler(bank)}
                        >
                          <p>{bank.label}</p>
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            </TextField>
            {this.errorChecker('bankName')}
          </Col>
        </Row>
        <Row>
          <Col md="12" style={{ padding: 0 }}>
            <TextField style={{ padding: '0px' }}>
              <div className="title-form">Seller Location</div>
              <FormGroup>
                <InputSelect
                  className="input-select"
                  name="_provinceSelected"
                  onChange={this._handleSelectProvinceChange}
                  value={this.state._provinceSelected}
                  options={this.state._provinceList}
                  placeholder="Select Province"
                  autocomplete="off"
                  disabled={this.state.isDisabledSellerLocation}
                  {...(this.state.isDisabledSellerLocation && {
                    style: {
                      backgroundColor: '#e9ecef',
                    },
                  })}
                />
              </FormGroup>
            </TextField>
            {this.errorChecker('_provinceSelected')}
          </Col>
        </Row>
        {/* {this._renderError()} */}
        {/* {this._renderError() && <Row>
            <Col style={{ marginTop: '1rem' }}>
              {this._renderError()}
            </Col>
          </Row>} */}
        <Row>
          <Col className="submit-button">
            <Button
              block
              size="lg"
              className="btn-green bold"
              disabled={this.state._disable || this.props.isSubmit}
              text="SUBMIT"
              buttonText="SUBMIT"
            />
          </Col>
        </Row>

        <ModalPhotoGuidance
          visible={this.state.isModalGuidanceOpen}
          selectedType={this.selectedType()}
          onCancel={() => {
            this.setState({
              isModalGuidanceOpen: false,
            });
          }}
        />
      </Form>
    );
    return <div>{content}</div>;
  }
}

const CardItem = styled.div`
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
`;

const CardSellerInfo = styled.div`
  padding: 10px 0;
`;

const CardInfo = styled.div`
  background-color: yellow;
`;

const TextField = styled.div``;

const mapDispatchToProps = (dispatch) => ({
  postUserBankAccount: (payload) => dispatch(postUserBankAccount(payload)),
  getProvinces: () => dispatch(doFetchProvinces()),
  fetchBankList: () => dispatch(getBankList()),
});

const mapStateToProps = (state) => ({
  userdata: state.dataAuth,
  dataPostalCode: state.dataPostalCode,
  dataProvinces: state.dataPostalCode.provinces,
  dataBankList: state.dataPostalCode.bankList,
  dataUserBankAccount: state.dataPostalCode.userBankAccount,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SubmitPhoneV2));
